import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { AstroServiceService } from '../admin/services/astroservice/astro-service.service';
import { LanguageDataService } from '../admin/services/language/language-data.service';
import { UserdataService } from '../admin/services/shared/userdata/userdata.service';
import { SkillsServiceService } from '../admin/services/skills/skills-service.service';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-add-astrologer-open',
  templateUrl: './add-astrologer-open.component.html',
  styleUrls: ['./add-astrologer-open.component.scss'],
  standalone: false
})
export class AddAstrologerOpenComponent implements OnInit {
  selectedFileName: string = '';
  selectedProofFileName: string = '';
  matcher = new ErrorStateMatcher();
  days = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

  months = [
    { value: '01', label: 'Jan' },
    { value: '02', label: 'Feb' },
    { value: '03', label: 'Mar' },
    { value: '04', label: 'Apr' },
    { value: '05', label: 'May' },
    { value: '06', label: 'Jun' },
    { value: '07', label: 'Jul' },
    { value: '08', label: 'Aug' },
    { value: '09', label: 'Sep' },
    { value: '10', label: 'Oct' },
    { value: '11', label: 'Nov' },
    { value: '12', label: 'Dec' }
  ];

  years = Array.from({ length: 100 }, (_, i) => (new Date().getFullYear() - i).toString());


  addAstrologerForm: any = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')]),
    gender: new FormControl('', [Validators.required]),
    alternate_num: new FormControl('', [Validators.pattern('[6-9]{1}[0-9]{9}')]),
    profile_image: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required]),
    consultant_type: new FormControl('Astrologer'),
    experience: new FormControl('', [Validators.required, Validators.pattern('[0-9]{1,2}')]),
    lang: new FormControl('', [Validators.required]),
    skill: new FormControl('', [Validators.required]),
    complete_address: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    pincode: new FormControl('', [Validators.required]),
    bank_account_num: new FormControl('', [Validators.required]),
    account_type: new FormControl('', [Validators.required]),
    ifsc: new FormControl('', [Validators.required]),
    account_holder_name: new FormControl('', [Validators.required]),
    pan_number: new FormControl('', [Validators.required]),
    addhar_number: new FormControl('', [Validators.required, Validators.pattern('[0-9]{12}')]),
    working_with_other: new FormControl('', [Validators.required]),
    short_bio: new FormControl('', [Validators.required]),
    long_bio: new FormControl('', [Validators.required]),
    proof_image: new FormControl('', [Validators.required])
  })

  rows = [];
  skillsData: any = [];
  languageData: any = [];
  public skills: Array<any> = [];
  public languages: Array<any> = [];
  i: any;
  day: any = [];
  month: any = [];
  year: any = [];
  selectedLanguage: any = [];
  selectedLanguageJson: any = [];
  selectedSkills: any = [];
  selectedSkillsJson: any = [];
  getWorkingStatus: Boolean | any;


  constructor(
    private spinner: NgxSpinnerService,
    private skillsService: SkillsServiceService,
    private userdata: UserdataService,
    private language: LanguageDataService,
    private astroService: AstroServiceService,
    private toastr: ToastrService,
    private route: Router
  ) { }

  ngOnInit(): void {
    this.getSkillsList();
    this.getLaguangeList();
  }

  proofError: string = '';
  public onProofImageUpload(evnt: any) {
    const input = evnt.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedProofFileName = input.files[0].name;
      if (evnt.target.files.length > 0) {
        this.proofError = ''
        if (evnt.target.files.length > 0) {
          if (evnt.target.files && evnt.target.files[0]) {
            const allowed_types = ['image/png', 'image/jpeg'];
            if (!_.includes(allowed_types, evnt.target.files[0].type)) {
              this.proofError = 'Only Images are allowed ( JPG | PNG )';
              return;
            } else {
              this.addAstrologerForm.patchValue({
                proof_image: evnt.target.files[0]
              })
            }
          }
        }
      }
    }

  }

  profileError: string = '';
  public onProfileImageUpload(evnt: any) {
    const input = evnt.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFileName = input.files[0].name;
      this.profileError = ''
      if (evnt.target.files.length > 0) {
        if (evnt.target.files && evnt.target.files[0]) {
          const allowed_types = ['image/png', 'image/jpeg'];
          if (!_.includes(allowed_types, evnt.target.files[0].type)) {
            this.profileError = 'Only Images are allowed ( JPG | PNG )';
            return;
          } else {
            this.addAstrologerForm.patchValue({
              profile_image: evnt.target.files[0]
            })
          }
        }
      }
    }


  }

  getLaguangeList() {
    this.spinner.show()
    this.language.getLaguangeList({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.languageData = res.data;
        for (this.i = 0; this.i < this.languageData.length; this.i++) {
          this.languages.push({ 'display': this.languageData[this.i].name, 'value': this.languageData[this.i]._id });
        }
      },
      (err) => {
        //console.log(err);
      }
    );
  }

  getSkillsList() {
    this.spinner.show()
    this.skillsService.getSkillsList({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.skillsData = res.data;
        for (this.i = 0; this.i < this.skillsData.length; this.i++) {
          this.skills.push({ 'display': this.skillsData[this.i].skillname, 'value': this.skillsData[this.i]._id });
        }
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  get f() {
    return this.addAstrologerForm.controls
  }

  //-------tags json------//

  public onAddAstrologerSubmit() {
    this.spinner.show()


    var convertBoolean = this.addAstrologerForm.get("working_with_other").value

    if (convertBoolean == "yes") {
      this.getWorkingStatus = true;
    } else {
      this.getWorkingStatus = false;
    }
    const data = new FormData()
    const dob = this.addAstrologerForm.value.dob;
    if (dob) {
      let day = dob.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      let month = dob.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      const year = dob.getFullYear();
      data.append('birth_date', day.toString());
      data.append('birth_month', month.toString());
      data.append('birth_year', year.toString());
    }

    data.append("name", this.addAstrologerForm.get("name").value)
    data.append("email", this.addAstrologerForm.get("email").value)
    data.append("password", this.addAstrologerForm.get("password").value)
    data.append("phone", this.addAstrologerForm.get("phone").value)
    data.append("gender", this.addAstrologerForm.get("gender").value)
    data.append("alternate_num", this.addAstrologerForm.get("alternate_num").value)
    data.append("profile_image", this.addAstrologerForm.get("profile_image").value)
    data.append("consultant_type", this.addAstrologerForm.get("consultant_type").value)
    data.append("experience", this.addAstrologerForm.get("experience").value)
    const langArray = this.addAstrologerForm.value.lang.map((id: string) => ({ langId: id }));
    const skillArray = this.addAstrologerForm.value.skill.map((id: string) => ({ skillId: id }));
    data.append("lang", JSON.stringify(langArray));
    data.append("skill", JSON.stringify(skillArray));
    data.append("complete_address", this.addAstrologerForm.get("complete_address").value)
    data.append("city", this.addAstrologerForm.get("city").value)
    data.append("state", this.addAstrologerForm.get("state").value)
    data.append("country", this.addAstrologerForm.get("country").value)
    data.append("pincode", this.addAstrologerForm.get("pincode").value)
    data.append("bank_account_num", this.addAstrologerForm.get("bank_account_num").value)
    data.append("account_type", this.addAstrologerForm.get("account_type").value)
    data.append("ifsc", this.addAstrologerForm.get("ifsc").value)
    data.append("account_holder_name", this.addAstrologerForm.get("account_holder_name").value)
    data.append("pan_number", this.addAstrologerForm.get("pan_number").value)
    data.append("addhar_number", this.addAstrologerForm.get("addhar_number").value)
    data.append("working_with_other", this.getWorkingStatus)
    data.append("short_bio", this.addAstrologerForm.get("short_bio").value)
    data.append("long_bio", this.addAstrologerForm.get("long_bio").value)
    data.append("proof_image", this.addAstrologerForm.get("proof_image").value)
    const isSocialLogin = false;
    data.append("is_social_login", String(isSocialLogin));


    this.astroService.addAstrologerOpen(data).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.toastr.success(res.message || 'Astrologer Registered Successfully!', 'Success');
          Swal.fire('Astrologer Registered Successfully!', "We'll contact you shortly", "success");
          this.addAstrologerForm.reset()
        } else {
          this.toastr.error(res.message || 'Something went wrong', 'Error');
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.toastr.error(err?.error?.message || 'Something went wrong', 'Error');
      }
    });

  }

  reloadCurrentRoute() {
    let currentUrl = this.route.url;
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.route.navigate([currentUrl]);
    });
  }

}
